import { createContextualCan } from "@casl/react";
import { useContext } from "react";

import { AbilityContext } from "@/lib/ability-context";

/** ADV-879: hook returns the user's AppAbility for use in conditional logic. */
export const useAbility = () => useContext(AbilityContext);

/** ADV-879: declarative gate. `<Can I="reset" a="Business">...</Can>`. */
export const Can = createContextualCan(AbilityContext.Consumer);
